module.exports = __webpack_public_path__ + "static/media/mon2.438a8bea.png";